import { render, staticRenderFns } from "./eventLayout.vue?vue&type=template&id=5f11a1f2&scoped=true&"
import script from "./eventLayout.vue?vue&type=script&lang=js&"
export * from "./eventLayout.vue?vue&type=script&lang=js&"
import style0 from "./eventLayout.vue?vue&type=style&index=0&id=5f11a1f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f11a1f2",
  null
  
)

export default component.exports